












































// Packages
import Vue from 'vue';
import {
  mapActions,
  mapGetters,
} from 'vuex';

// Types
import { IPublicUserObject } from '../../../../../shared/types';

interface IData {
  mode: number;
  name: string;
  imageUrl: string;
  privateMode: boolean;
}

interface IMethods {
  updateUser: (user: Record<string, string | boolean>) => void;
  toggleMode: () => void;
  save: () => void;
}

interface IComputed {
  getUser: IPublicUserObject;
  isUser: boolean;
  actionText: string;
}

interface IProps {
  user: IPublicUserObject;
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'ProfileHeader',

  props: {
    user: {
      type: Object as () => IPublicUserObject,
      required: true,
    },
  },

  data: () => ({
    mode: 0,

    name: '',

    imageUrl: '',

    privateMode: true,
  }),

  computed: {
    ...mapGetters('user', [
      'getUser',
    ]),

    isUser() {
      return this.user.id === this.getUser.id;
    },

    actionText() {
      return this.mode === 0 ? 'Edit' : 'Save';
    },
  },

  methods: {
    ...mapActions('user', [
      'updateUser',
    ]),

    toggleMode() {
      if (this.mode === 1) {
        this.save();
      } else {
        this.name = this.user.name;
        this.imageUrl = this.user.imageUrl;
        this.privateMode = this.user.private;
      }

      this.mode = this.mode === 0 ? 1 : 0;
    },

    async save() {
      await this.updateUser({
        name: this.name,
        imageUrl: this.imageUrl,
        privateMode: this.privateMode,
      });
    },
  },
});
